<template>
  <div v-if="!loading" class="pc-mode">
    <site-header/>
    <div class="container">
      <article>
        <ol class="breadcrumb" v-if="line">
          <li class="breadcrumb-item"><router-link :to="{ name: 'SiteTopArea', params: { areaId }}">トップページ</router-link></li>
          <li class="breadcrumb-item" aria-current="page">履歴一覧／</li>
          <li>{{ line.line_name }}<span v-if="line.section_name">({{ line.section_name}})</span></li>
        </ol>
        <div class="time-now">
          <h1>履歴一覧</h1>
          <span class="now-time">{{ today | jpYYYYMMDDdd }}現在</span>
          <br>
          <span>過去45日間の履歴が表示されます。</span>
        </div>
        <h4 class="line-label" v-if="line">
          <span>
            <i :style="{ background: line.line_color_1, color: lineSignColor(line.line_sign_color_1) }">{{ line.line_sign_1 }}</i><i v-if="line.line_sign_2" :style="{ background: line.line_color_2, color: lineSignColor(line.line_sign_color_2) }">{{ line.line_sign_2 }}</i><i v-if="line.line_sign_3" :style="{ background: line.line_color_3, color: lineSignColor(line.line_sign_color_3) }">{{ line.line_sign_3 }}</i>
          </span>
          <div class="line-info">
            <span class="line-name">{{ line.line_name }}</span>
            <span class="section-name">{{ line.section_name }}</span>
          </div>
        </h4>
        <table class="w-100">
          <thead id="thead">
            <tr>
              <th :style="{ width: '270px'}" class="text-center">日付</th>
              <th class="th-timezone text-center" v-bind:key="timeZone.time_zone_id" v-for="timeZone in timeZones" :style="{ width: timeZone.historyCellWidth}">{{ timeZone.display_name }}</th>
            </tr>
          </thead>
          <tbody id="tbody">
            <!-- for fixed cell width -->
            <tr class="fixed-width">
              <th :style="{ width: '270px'}"></th>
              <th v-bind:key="timeZone.time_zone_id" v-for="timeZone in timeZones" :style="{ width: timeZone.historyCellWidth}"></th>
            </tr>
            <!-- for fixed cell width --- END -->
            <tr v-bind:key="history.date" v-for="history in getHistorys()">
              <td class="text-center history-date">
                {{ history.date | jpmonthday}}
              </td>
              <td class="text-center align-top" v-bind:key="zoneData.time_zone_id" v-for="zoneData in history.data">
                <router-link v-bind:class="{ is_modified: zoneData.is_modified === true }" target="_blank" class="btn-delay" v-if="zoneData.delay_certificate_item_type === 'DELAY_CERTIFICATE'" :to="{name: 'HistoryDelayCertificate', params: { today:'history', areaId: areaId, lineId: lineId, targetDate: history.date, timeZoneId: zoneData.time_zone_id }}">
                  <div>
                    <img src="../../assets/images/delay_icon.png"/><br/>
                    <span id="delay_time">{{ zoneData.delay_certificate }}</span><br/>
                    <span id="str_modified" v-if="zoneData.is_modified === true">変更</span>
                  </div>
                </router-link>
                <span class="string-delay" v-bind:class="[ zoneData.delay_certificate === '調整中' ? 'maintenance' : '', zoneData.delay_certificate !== 'ー' ? 'into_target_time' : 'out_of_target_time' ]" v-else-if="zoneData.delay_certificate_item_type === 'OTHERS'">
                  <span v-html="divideStringDelay(zoneData.delay_certificate)"></span><br/>
                  <span id="str_modified" v-if="zoneData.is_modified === true">変更</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="historyMaintenanceCSV" id="maintenance_csv" v-html="historyMaintenanceCSV"></div>
        <b-button class="more-btn" v-show="historys.length > 0 && this.displayAll === false" variant="btn-block" v-on:click="ondisplayAll">
          もっと見る
          <span v-if="this.displayAll === false"><font-awesome-icon :icon="['fas', 'caret-down']"></font-awesome-icon></span>
        </b-button>
        <b-button class="more-btn" id="close_btn" v-show="historys.length > 0 && this.displayAll === true" variant="btn-block" v-on:click="ondisplayAll">
          閉じる
          <span v-if="this.displayAll === true"><font-awesome-icon :icon="['fas', 'caret-up']"></font-awesome-icon></span>
        </b-button>
      </article>
    </div>
    <site-footer/>
  </div>
</template>

<script>
import SiteHeader from '@/components/pc/SiteHeader'
import SiteFooter from '@/components/pc/SiteFooter'
import { mapState } from 'vuex'
var moment = require('moment')
export default {
  name: 'SiteTop',
  components: {
    SiteHeader,
    SiteFooter
  },
  data () {
    const today = moment()
    const areaId = parseInt(this.$route.params.areaId, 10)
    const lineId = parseInt(this.$route.params.lineId, 10)
    return {
      today,
      areaId,
      lineId,
      theadYPos: 0,
      scrollInit: true,
      area: undefined,
      line: undefined,
      displayAll: false
    }
  },
  methods: {
    isNum (num) {
      return num !== undefined && /^\d+$/.test(num) === true
    },
    ondisplayAll () {
      this.displayAll = !this.displayAll
    },
    getHistorys () {
      if (this.displayAll) {
        return this.historys
      } else {
        return this.historys.slice(0, 7)
      }
    },
    divideStringDelay (stringDelay) {
      if (stringDelay === '掲載はありません') {
        return '掲載は<br/>ありません'
      } else if (stringDelay === '掲載準備中') {
        return '掲載<br/>準備中'
      } else if (stringDelay === '調整中') {
        return '<br/>調整中'
      } else if (stringDelay === '掲載不可') {
        return '<br/>掲載不可'
      } else {
        return stringDelay
      }
    },
    lineSignColor (data) {
      return data === '' ? '#000' : data
    },
    onScroll () {
      var thead = document.getElementById('thead')
      var tbody = document.getElementById('tbody')
      if (this.scrollInit) {
        this.theadYPos = thead.getBoundingClientRect().bottom
        this.scrollInit = false
      }
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition >= this.theadYPos) {
        thead.classList.add('position-fixed')
        tbody.style.paddingTop = '40px'
      } else {
        thead.classList.remove('position-fixed')
        tbody.style.paddingTop = '0'
      }
    },
    init () {
      if (this.areaStatus !== 'init' || this.timeZoneStatus !== 'init') {
        return
      }
      this.area = this.areas.find(area => area.area_id === this.areaId)
      if (this.area === undefined) {
        this.$router.push({path: '/404'})
        return
      }
      this.line = this.area.lines.find(line => line.line_id === this.lineId)
      if (this.line === undefined) {
        this.$router.push({path: '/404'})
        return
      }
      this.$store.dispatch('history/all', [this.lineId, this.timeZones])
      this.$store.dispatch('externalData/historyMaintenanceCSV', this.areaId)
      this.checkLoaded()
    },
    checkLoaded () {
      const timer = setInterval(() => {
        if (this.historyStatus === 'init') {
          clearInterval(timer)
          this.$store.commit('loading/setStatus', false)
        }
      }, 100)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
    this.scrollInit = true
  },
  created () {
    window.scrollTo(0, 0)
    if (!this.isNum(this.$route.params.areaId) ||
      !this.isNum(this.$route.params.lineId)) {
      this.$router.push({path: '/404'})
      return
    }
    this.$store.dispatch('areaLine/all')
    this.$store.dispatch('timeZone/all')
    const unwatchAreaLine = this.$store.watch(
      (state) => state.areaLine.status,
      (value) => {
        if (value === 'init') {
          unwatchAreaLine()
          this.init()
        }
      }
    )
    const unwatchTimezone = this.$store.watch(
      (state) => state.timeZone.status,
      (value) => {
        if (value === 'init') {
          unwatchTimezone()
          this.init()
        }
      }
    )
  },
  computed: {
    ...mapState('timeZone', {
      timeZones: state => state.timeZones,
      timeZoneStatus: state => state.status
    }),
    ...mapState('history', {
      historys: state => state.historys,
      historyStatus: state => state.status
    }),
    ...mapState('externalData', {
      historyMaintenanceCSV: state => state.historyMaintenanceCSV
    }),
    ...mapState('areaLine', {
      areas: state => state.areas,
      areaStatus: state => state.status
    }),
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
.breadcrumb {
  li {
    color: #1a1a1a !important;
    font-weight: 600 !important;
  }
  .breadcrumb-item {
    color: #1a1a1a !important;
    font-weight: 600 !important;
    a {
      color: #1a1a1a !important;
      font-weight: 600 !important;
    }
  }
}
footer {
  min-width: 970px;
}
ol.breadcrumb {
  li {
    color: #757575;
  }
}
div.time-now {
  border-bottom: solid 2px #3070B3;
  padding-bottom: 23px;
  h1 {
    font-weight: 600;
    margin-bottom: 9px;
    padding-bottom: 0px;
    padding-left: 0px !important;
    padding-top: 0px;
  }
  span {
    margin-bottom: 0;
    &.now-time {
      line-height: 1.1rem;
      font-size: 1rem;
      font-weight: 600;
      line-height: 1.1rem;
      color: $primary;
    }
  }
}
h4.line-label {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 16px;
  padding-bottom: 16px;
  font-size: 21px;
  text-align: center;
  margin-bottom: 30px;
  margin-top: 30px;
  border: solid 2px #f5f5f5;
  vertical-align: middle;
  font-weight: 600;
  i {
    font-style: normal;
    width: 35px;
    height: 35px;
    padding: 7px;
    text-align: center;
    color: white;
    display: block;
    margin-bottom: 1px;
    border-radius: 3px;
  }
  .line-info {
    text-align: left;
    display: inline-block;
    margin-left: 10px;
    span {
      display: block;
      &.line-name {
        font-size: 24px;
        line-height: 24px;
        color: #1a1a1a;
        font-weight: 600;
        margin-bottom: 4px;
      }
      &.section-name {
        font-size: 14px;
        line-height: 21px;
        color: #a7a7a7;
        font-weight: 600;
      }
    }
  }
}
#maintenance_csv {
  margin-top: 20px;
}
table {
  border-collapse: separate;
  thead {
    &.position-fixed {
      position: fixed;
      background-color: white;
      width: 970px;
      margin-left: -2px;
      top: 0;
    }
    th {
      font-weight: normal;
      font-size: 14px;
      font-weight: 600;
      height: 40px;
      background-color: $table-th-normal;
    }
  }
  tbody {
    tr {
      height: 72px;
      &.fixed-width {
        height: 0;
        td {
          height: 0;
        }
      }
      td {
        height: 72px;
        border-bottom: solid 1px #979797;
        vertical-align: middle !important;
        &.history-date {
          font-size: 15px;
          line-height: 21px;
          padding-top: 10px;
          padding-bottom: 10px;
          font-weight: 600;
        }
        &.no-info {
          font-size: 16px;
          color: #a7a7a7;
        }
        .string-delay {
          display: inline-block;
          margin-top: 5px;
          margin-bottom: 0;
          color:#a7a7a7;
          &.maintenance{
            min-height: 39px !important;
            color: #fa7d00;
          }
          &.into_target_time{
            min-height: 57px !important;
          }
          #str_modified {
            font-size: 12px;
            line-height: 16px;
            color: #fa7d00;
          }
        }
        .btn-delay {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e0f2ff;
          border: solid 2px #abcbe8;
          border-radius: 0px;
          color: #3070b3;
          min-height: 63px !important;
          max-height: 63px;
          height: 63px;
          font-size: 18px;
          font-weight: 600;
          min-width: 80px;
          div {
            min-height: 63px !important;
          }
          img {
            width: 10px;
            height: 10px;
          }
          &:hover {
            border: solid 2px $primary;
          }
          #delay_time {
            font-size: 18px;
            line-height: 12px;
          }
          #str_modified {
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
            color: #fa7d00;
          }
        }
      }
    }
  }
}
.more-btn {
  width: 130px;
  height: 44px;
  margin: auto;
  color: black;
  background-color: white;
  border-color: black;
  border-radius: 1;
  margin-left: 420px;
  margin-right: 420px;
  margin-top: 16px;
}
ul {
  list-style: none;
  padding-left: 0px;
  li:before {
    display: inline-block;
    content: "・";
    width: 1rem;
    color: $primary;
  }
  li {
    line-height: 1.6rem;
    .indent {
      padding-left: 2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/History.vue